export default __webpack_public_path__ + "fonts/Vacant-White.svg";